import { render, staticRenderFns } from "./ArchiveEvent.vue?vue&type=template&id=1618e402&scoped=true&lang=pug&"
import script from "./ArchiveEvent.vue?vue&type=script&lang=js&"
export * from "./ArchiveEvent.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveEvent.scss?vue&type=style&index=0&id=1618e402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618e402",
  null
  
)

export default component.exports